
<template>
  <div id="page-data-view">

    <vx-card title="Maintenance Information" class="mb-base">
      <!-- Avatar -->
      <div class="vx-row">

        <!-- Information - Col 1 -->
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">Location</td>
              <td>{{ view_data.location }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Title</td>
              <td>{{ view_data.title }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Description</td>
              <td>{{ view_data.description }}</td>
            </tr>
            <tr>
              <td class="font-semibold" v-if="accessLevel >= 96">Requestor's Availabilty</td>
              <td class="font-semibold" v-else>Availability</td>
              <td>{{ view_data.availability === null ||  view_data.availability === '' ? '--' : view_data.availability }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 1 -->

        <!-- Information - Col 2 -->
        <div class="vx-col flex-1" id="account-info-col-2" v-if="accessLevel >= 96">
          <table>
            <tr>
              <td class="font-semibold">Types</td>
              <td>{{ rfp_type_name }}</td>
            </tr>

            <tr>
              <td class="font-semibold">Request No</td>
              <td>{{ view_data.request_no }}</td>
            </tr>

            <tr>
              <td class="font-semibold">Status</td>
              <td>{{ view_data.m_request_status.name }}</td>
            </tr>

            <tr v-if="roleVal === 'admin'">
              <td class="font-semibold">Manager's Notes</td>
              <td>{{ view_data.notes === null ||  view_data.notes === '' ? '--' : view_data.notes }}</td>
            </tr>

            <tr>
              <td class="font-semibold">Requested By</td>
              <td>{{ view_data.user.first_name +' '+ view_data.user.last_name }}</td>
            </tr>

            <tr>
              <td class="font-semibold">Received By</td>
              <td>{{ view_data.request_to === null ? 'Unseen' : request_to }}</td>
            </tr>

            <tr v-if="accessLevel >= 96">
              <td class="font-semibold">Assigned To</td>
              <td>{{ assigned_to_name === null ? 'Unassigned' : assigned_to_name }}</td>
            </tr>

            <tr>
              <td class="font-semibold">Date Created</td>
              <td>{{ view_data.createdAt | date(true) }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 2 -->

        <div class="vx-col w-full flex" id="account-manage-buttons" v-if="roleVal === 'staff' || roleVal === 'vendor' ">
          <vs-button class="mr-2" @click="confirmComplete" color="success" type="filled" :disabled=" view_data.m_request_status.val==='completed' || view_data.m_request_status.val==='decline' ">Completed</vs-button>
          <vs-button color="grey" icon-pack="feather" icon="icon-x" class="mr-4" @click="confirmDecline" v-if="!is_seen" :disabled=" view_data.m_request_status.val==='completed' || view_data.m_request_status.val==='decline' ">Decline</vs-button>
        </div>

        <div class="vx-col w-full flex" id="account-manage-buttons" v-else>
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4"
          :disabled="!showU" @click="maintenanceType(0)">Edit <!-- crud -->
          </vs-button>
           <vs-button icon-pack="feather" icon="icon-book-open" class="mr-4"
          :disabled="!showU" @click="maintenanceType(1)" v-if="roleVal === 'admin'">Work Order <!-- crud -->
          </vs-button>
           <vs-button icon-pack="feather" icon="icon-file-text" class="mr-4"
          :disabled="!showU" @click="maintenanceType(2)" v-if="roleVal === 'admin'">RFP <!-- crud -->
          </vs-button>
          <!-- <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord"
          :disabled="!showD">Delete
          </vs-button> -->
          <vs-button @click="popupActive=true" color="warning" type="border" class="" v-if="roleVal === 'admin'">
            <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4"/>
          Actions</vs-button>
        </div>

        <div class="vx-col w-full flex" id="account-manage-buttons" v-if="false">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-order-edit', params: { editId: $route.params.viewId }}" v-if="is_seen">Edit</vs-button>
          <vs-button color="success" icon-pack="feather" icon="icon-check" class="mr-4" @click="acceptJob($route.params.viewId)" v-else-if="!is_seen">Accept</vs-button>
          <vs-button color="danger" icon-pack="feather" icon="icon-x" class="mr-4" @click="rejectJob($route.params.viewId)" v-if="!is_seen">Decline</vs-button>

          <div class="w-full" v-if="is_seen">
            <div class="timerDue">
              <div style="width: auto;background: #e15e6d;border-radius: 5px;">

                <div class="count-down text-center">
                  <countdown :time="new Date(view_data.eta_dt).getTime() - new Date().getTime()">
                    <template slot-scope="props">
                      <div class="single-counter p-2">
                        <img src="@/assets/images/axp/timelog3.gif">
                      </div>

                      <div class="single-counter">
                        <span class="timer">{{ props.days }}</span>
                        <span>Days</span>
                      </div>

                      <div class="single-counter">
                        <span class="timer">{{ props.hours }}</span>
                        <span>Hours</span>
                      </div>

                      <div class="single-counter">
                        <span class="timer">{{ props.minutes }}</span>
                        <span>Minutes</span>
                      </div>

                      <div class="single-counter">
                        <span class="timer">{{ props.seconds }}</span>
                        <span>Seconds</span>
                      </div>
                    </template>
                  </countdown>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <div class="vx-row" v-if="roleVal === 'admin'">
      <div class="vx-col lg:w-1/2 w-full">
        <vx-card title="Request Details" class="mb-base">
          <table>
            <tr>
              <td class="font-semibold">Property Name</td>
              <td v-if="view_data.property !== null">{{ view_data.property.name }}</td>
            </tr>

            <tr>
              <td class="font-semibold">Issued By</td>
              <td>{{ issued_name }}</td>
            </tr>

            <tr>
              <td class="font-semibold">Scope</td>
              <td>{{ view_data.scope === null ||  view_data.scope === '' ? '--' : view_data.scope }}</td>
            </tr>

            <!-- <tr>
              <td class="font-semibold">Recipient</td>
              <td>{{ view_data.rfp_recipients === null ||  view_data.rfp_recipients === '' ? '--' : view_data.rfp_recipients }}</td>
            </tr> -->

            <!-- <tr v-for="(v, k) in rfp_recipients">
              <td class="font-semibold" v-if="k == 0">Recipients</td>
              <td class="font-semibold" v-else-if="k != 0"></td>
              <td v-if="v.business_name !== null">{{ v.business_name }}</td>
            </tr>  -->

            <tr>
              <td class="font-semibold">Other Comments</td>
              <td>{{ view_data.other_comments === null ||  view_data.other_comments === '' ? '--' : view_data.other_comments }}</td>
            </tr>
          </table>
        </vx-card>
      </div>

      <div class="vx-col lg:w-1/2 w-full">
        <vx-card title="RFP Key Dates" class="mb-base">
          <table>
            <tr>
              <td class="font-semibold">Issued Date</td>
              <td v-if="view_data.rfp_issue_date !== null">{{new Date(view_data.rfp_issue_date) | date(true) }}</td>
              <td v-else>--</td>
            </tr>

            <tr>
              <td class="font-semibold">Send Question Date</td>
              <td v-if="view_data.send_question_date !== null">{{new Date(view_data.send_question_date) | date(true) }}</td>
              <td v-else>--</td>
            </tr>

            <tr>
              <td class="font-semibold">Due Date</td>
              <td v-if="view_data.rfp_due_date !== null">{{new Date(view_data.rfp_due_date) | date(true) }}</td>
              <td v-else>--</td>
            </tr>

            <tr>
              <td class="font-semibold">Decision Date</td>
              <td v-if="view_data.decision_date !== null">{{new Date(view_data.decision_date) | date(true) }}</td>
              <td v-else>--</td>
            </tr>
          </table>
        </vx-card>
      </div>
    </div>

    <vx-card title="Images" class="mb-base">
      <!-- Avatar -->
      <div class="vx-row">
        <!-- Information - Col 1 -->
        <!-- reading docs -->
        <div class="vx-col flex-1">
          <div class="flex items-start flex-col sm:flex-row">
            <div v-if="files.length > 0" v-for="(item, file) in files">
              <span class="flex">
                <img :src="item"  class="mt-4 mr-8 rounded h-24 w-24" @click="showMultiple(file)" />
              </span>
            </div>
            <p v-if="files.length == 0">No files uploaded</p>
          </div>
        </div>
        <!-- /Information - Col 1 -->
      </div>
    </vx-card>

    <vx-card title="RFP Lists" class="mb-base" v-if="roleVal === 'admin'">
      <request-list class="mb-4" />
    </vx-card>

    <vx-card id='threadCard' :class="{'cardGlow':is_glow }" ref="threadCard" title="Threads" class="mb-base">
      <thread-list class="mb-4" />
    </vx-card>

    <div class="vx-col lg:w-1/2 w-full" v-if="roleVal === 'admin'">
        <vx-card title="Approvals" class="mb-base">
          <approval
          :items="approvals"
          :reference_id="view_data.id"
          :reference_no="view_data.request_no"
          type="wo"
          class="mb-4" />
        </vx-card>
    </div>

    <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
      <span>Data record with id: {{ $route.params.viewId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-order-list'}" class="text-inherit underline">All Data</router-link>
      </span>
    </vs-alert>

    <vue-easy-lightbox
      :visible="visible"
      :imgs="files"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>

    <vs-popup classContent="popup-example order-view-pop-f" title="Select Action" :active.sync="popupActive">
      <div class="vx-col w-full selectOption" style="overflow: hidden;">

        <div class="mt-6">
          <vs-button class="mr-2" @click="reOpen(16)" color="warning" type="filled" :disabled="view_data.is_assigned !== 1 && view_data.is_submitted !== 1 && view_data.m_request_status.val!=='completed' " v-if="!(accessLevel <= 96)">Reopen</vs-button>
          <vs-button class="mr-2" @click="updateStatus('completed')" color="success" type="filled" :disabled="view_data.m_request_status.val==='completed' || view_data.m_request_status.val==='closed'">Completed</vs-button>
          <vs-button class="mr-2" @click="updateStatus('closed')" color="gray" type="filled" :disabled="view_data.m_request_status.val==='closed'" v-if="!(accessLevel <= 96)">Close</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup v-if="false" :classContent="{'popup-example':true, 'order-view-pop-t':view_data.assigned_to_type < 3, 'order-view-pop-f':view_data.assigned_to_type==3}" title="Select Action" :active.sync="popupActive">
      <div class="vx-col w-full selectOption" style="overflow: hidden;">
        <div class="vx-row mb-base">
          <div class="mt-4 w-full vx-col">
            <label class="text-sm">Assigned To</label>
            <div class="flex flex-wrap mt-2" @click="clearSelectAssign()">
              <vs-radio v-model="view_data.assigned_to_type" vs-value="1" value="1" class="mr-4" v-if="!(accessLevel <= 96)">Staff</vs-radio >
              <vs-radio v-model="view_data.assigned_to_type" vs-value="2" value="2" class="mr-4" v-if="!(accessLevel <= 96)">Vendor</vs-radio >
              <vs-radio v-model="view_data.assigned_to_type" vs-value="3" value="3" class="mr-4">No Action</vs-radio >
            </div>
          </div>
        </div>

        <div class="vx-row mb-base" style="height:220px;" v-if="view_data.assigned_to_type<3">
          <div class="mt-4 w-full vx-col" v-if="view_data.assigned_to_type == 1">
            <label class="text-sm">Email</label>
            <v-select :options="optionStaff" :reduce="email => email.id" label="email" v-model="view_data.assigned_to" name="assigned_to" v-validate="'required'"/>
            <span class="text-danger text-sm"  v-show="errors.has('assigned_to')">{{ errors.first('assigned_to') }}</span>
          </div>

          <div class="mt-4 w-full vx-col" v-if="view_data.assigned_to_type == 2">
            <label class="text-sm">Email</label>
            <v-select :options="optionVendor" :reduce="business_name => business_name.id" label="business_name" v-model="view_data.assigned_to" name="assigned_to" v-validate="'required'"/>
            <span class="text-danger text-sm"  v-show="errors.has('assigned_to')">{{ errors.first('assigned_to') }}</span>
          </div>

          <div class="w-full vx-col" v-if="view_data.assigned_to_type < 3">
            <div class="vx-row">
              <div class="w-1/2 vx-col" >
                <label class="vs-input--label">Estimated Date</label><br>
                <flat-pickr :config="configETA" v-model="view_data.eta_dt" placeholder="Select Date" :class="{'flatpickr-input':true, 'w-full':true }"/>
              </div>

              <div class="w-1/2 vx-col">
                <label class="text-sm">Direction</label>
                <vs-input class="w-full" v-model="view_data.direction" type="text" name="direction" v-validate="'required'"/>
                <span class="text-danger text-sm"  v-show="errors.has('direction')">{{ errors.first('direction') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="mt-6">
          <vs-button class="mr-2" @click="assignOrder" color="primary" type="filled" :disabled="view_data.assigned_to_type == 3 || this.view_data.assigned_to === null || view_data.m_request_status.val==='completed' ">Assign</vs-button>
          <vs-button class="mr-2" @click="reOpen(16)" color="warning" type="filled" :disabled="view_data.is_submitted !== 1 && view_data.m_request_status.val!=='completed' " v-if="!(accessLevel <= 96)">Reopen</vs-button>
          <vs-button class="mr-2" @click="updateStatus('completed')" color="success" type="filled" :disabled="view_data.assigned_to_type < 3 || view_data.m_request_status.val==='completed' ">Completed</vs-button>
          <vs-button class="mr-2" @click="updateStatus('closed')" color="gray" type="filled" :disabled="view_data.assigned_to_type < 3" v-if="!(accessLevel <= 96)">Closed</vs-button>
        </div> -->
      </div>
    </vs-popup>

    <!--
    <tr v-if="accessLevel >= 96">
      <td class="font-semibold">Urgency</td>
      <td>{{ view_data.urgency }}</td>
    </tr>

     <tr v-if="accessLevel >= 96">
      <td class="font-semibold">Assigned To</td>
      <td>{{ view_data.assigned_to_name === null ? 'Unassigned' : view_data.assigned_to_name }}</td>
    </tr>

    <tr v-if="accessLevel >= 96">
      <td class="font-semibold">Direction</td>
      <td>{{ view_data.direction === null ||  view_data.direction === '' ? '--' : view_data.direction }}</td>
    </tr>
    <tr v-if="accessLevel >= 96">
      <td class="font-semibold">Due Date</td>
      <td v-if="view_data.eta_dt === null">--</td>
      <td v-else-if="view_data.eta_dt !== null">{{ new Date(view_data.eta_dt) | date(true) }}</td>
    </tr> -->

    <!-- <tr v-for="(dt, key) in view_data.maintenance_request_dts">
      <td class="font-semibold" v-if="key == 0">Availability</td>
      <td class="font-semibold" v-else-if="key != 0"></td>
      <td>
        {{ new Date(dt.start_date) | date(true) }} ( {{ dt.start_time | time }} to {{ dt.end_time | time }} )
      </td>
    </tr> -->

    <!-- <tr>
      <td class="font-semibold">User Email</td>
      <td v-if="view_data.user !== null">{{ view_data.user.email }}</td>
    </tr>

    <tr>
      <td class="font-semibold">Building</td>
      <td v-if="view_data.building !== null">{{ view_data.building.name }}</td>
    </tr>

    <tr>
      <td class="font-semibold">First Name</td>
      <td>{{ view_data.user.first_name }}</td>
    </tr>

    <tr>
      <td class="font-semibold">Last Name</td>
      <td>{{ view_data.user.last_name }}</td>
    </tr>

    <tr>
      <td class="font-semibold">Unit No</td>
      <td v-if="view_data.unit !== null">{{ view_data.unit.number }}</td>
    </tr> -->

    <!-- <tr>
      <td class="font-semibold mr-4">Type</td>
      <td v-if="view_data.maintenance_type !== null">{{ view_data.maintenance_type.name }}</td>
    </tr> -->
    <!-- <tr>
      <td class="font-semibold">Category</td>
      <td v-if="view_data.vendor_category_master !== null">{{ view_data.vendor_category_master.name }}</td>
    </tr> -->
    <!-- <tr>
      <td class="font-semibold">Assigned To</td>
      <td v-if="view_data.vendor !== null">{{ view_data.vendor.name }}</td>
    </tr> -->
    <!-- <tr>
      <td class="font-semibold">Resolved Date</td>
      <td>{{ view_data.resolved_date | date(true) }}</td>
    </tr> -->
    <!-- <tr>
      <td class="font-semibold">Rfp Type</td>
      <td>{{ view_data.rfp_type }}</td>
    </tr> -->
    <!-- <tr>
      <td class="font-semibold">Is Seen</td>
      <td>{{ view_data.is_seen }}</td>
    </tr> -->

    <!-- <div class="vx-col w-full flex" id="account-manage-buttons" v-if="roleName == 'Admin'">
      <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-order-edit', params: { editId: $route.params.viewId }}">Edit</vs-button>
      <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Delete</vs-button>
    </div> -->

  </div>
</template>

<script>
import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud
import ThreadList     from '../../maintenance_thread/list/List.vue'
import RequestList     from './list/List.vue'
import VueCountdown from '@chenfengyuan/vue-countdown'
const jwt = require('jsonwebtoken')

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Approval from '../../../components/approval-widget/approval.vue'
import EventBus from '@/EventBus'

export default {
  components: {
    ThreadList,
    RequestList,
    'countdown': VueCountdown,
    vSelect,
    flatPickr,
    Approval,
  },
  data () {
    const token = localStorage.usertoken
    return {
      accessLevel: null,
      configETA: {
        enableTime: false,
        minDate: new Date(),
        maxDate: null,
        dateFormat: 'F j, Y',
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);
            }
        ]
      },

      is_glow: false,
      optionStaff: [],
      optionUser: [],
      optionVendor: [],
      request_to: null,
      popupActive: false,
      // rfp_recipients: [],
      optionType: [
        { id: 0, name: 'Request', val: 'request'},
        { id: 1, name: 'Work Order', val: 'work-order'},
        { id: 2, name: 'Proposal', val: 'proposal'},
        { id: 3, name: 'Information', val: 'information'}
      ],

      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,

      imgs: '',  // Img Url , string or Array of string
      visible: false,
      index: 0,   // default: 0

      token: token,
      roleName: '',
      is_seen: false,

      //maintenance
      view_data: {
        assigned_to_name: null,
        eta_dt: null,
        direction: null,
        vendor_email: null,
        due_date: null,
        assigned_to_type: 3,
        unit_resident_id: '',
        m_request_status_id: '',
        resolved_date: '',
        building_id: '',
        location: '',
        maintenance_type_id: '',
        urgency: '',
        description: '',
        image_filename: '',
        m_type_other_value: '',
        assigned_to: null,
        rfp_type: '',
        vendor_category_id: '',
        user_id: '',
        is_seen: '',
        property_id: '',
        unit_id: '',
        vendor: {
          name:'',
        },
        user: {
          name:'',
        },
        building: {
          name:'',
        },
        property: {
          name:'',
        },
        unit: {
          name:'',
        },
        maintenance_type: {
          name:'',
        },
        vendor_category_master: {
          name:'',
        },
      },
      approvals: [],
      data_not_found: false,

      //reading docs
      tableRead: [],
      files: [],
      fileKey: []
    }
  },
  methods: {
    maintenanceType(t){
      this.$router.push(`/orders/edit/${this.$route.params.viewId}?t=${t}`)
    },
    clearSelectAssign() {
      this.view_data.assigned_to = null
    },
    showMultiple(k) {
      this.index = k  // index of imgList
      this.show()
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.view_data.id}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    confirmComplete () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirm Complete',
        text: `Are you sure you want to update the status to Complete?`,
        accept: this.completeOrder,
        acceptText: 'Yes'
      })
    },
    async completeOrder() {
      try {
        const viewId = this.$route.params.viewId
        this.view_data.m_request_status_id = 8
        await axios.post(`/order/update-stat/${this.$route.params.viewId}`, {
          token: this.token,
          data: this.view_data
        })

        this.$vs.notify({
          color: 'success',
          title: 'Loading Page',
          text: 'Job completed.'
        })
        this.loadData()
      } catch(err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Loading Page',
          text: err
        })
      }
    },
    confirmDecline () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Please send a message to issuer`,
        accept: this.declineOrder,
        acceptText: 'Yes'
      })
    },
    async declineOrder() {
      try {
        const viewId = this.$route.params.viewId
        const userAllData = JSON.parse(localStorage.userAllData)

        await axios.post(`/order/reject/${viewId}`, {
          token: this.token,
          data: this.view_data
        })

        this.view_data.m_request_status_val = 'decline'
        await axios.post(`/order/update-stat/${this.$route.params.viewId}`, {
          token: this.token,
          data: this.view_data
        })

        this.$vs.notify({
          color: 'success',
          title: 'Loading Page',
          text: 'Job declined.'
        })
        this.loadData()

        this.$refs['threadCard'].$el.scrollIntoView({ behavior: 'smooth' });
        this.is_glow = true
      } catch(err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Loading Page',
          text: err
        })
      }
    },
    deleteRecord () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {
          await axios.post(`/order/delete/${viewId}`, {
              token: this.token
            })
            .then(res => {
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
              } else {
                // this.$router.push({name:'app-order-list'})
                this.showDeleteSuccess()
              }

            })
            .catch(err => {
              reject(err)
            })
        } catch(err) {
          reject(err.toString('utf8'));
        }

        d.then((res) => {
          this.data_local = res[0]
        })
      })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Data Deleted',
        text: 'The selected data was successfully deleted'
      })
    },
    //reading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    async loadData () {
      const loadUser = await this.loadUser()
      const viewId = this.$route.params.viewId
      const result = await axios.get(`/order/view/${viewId}`, {
        headers: { 'Authorization': this.token }
      })

      this.view_data = result['data']
      this.view_data.createdAt = new Date(this.view_data.createdAt)
      this.view_data.resolved_date = new Date(this.view_data.resolved_date)
      this.view_data.assigned_to = JSON.parse(this.view_data.assigned_to)
      console.log('this.view_data ', this.view_data)

      loadUser.filter((res) => {
        this.request_to = res.id === this.view_data.request_to ? res.full_name : this.request_to

        if (res.id === this.view_data.request_to) return
      })

      if(result['data'] == 'access_denied' || result['data'] == '') {
        this.$vs.notify({
          color: 'danger',
          title: 'Error loading',
          text: 'Something went wrong'
        })
        // this.$router.push({name:'app-order-list'})
      }

      this.approvals = this.view_data.approval
        ? this.view_data.approval.approval_items
            .sort((a, b) => a.level - b.level)
        : [];
      console.log('this.view_data.assigned_to_name ', this.view_data.assigned_to_name)
      this.request_to = this.optionUser.filter(res => res.id === this.view_data.request_to)
      this.request_to = this.view_data.request_to === null ? null : this.request_to[0]['full_name']
      this.view_data.assigned_to_type = this.accessLevel <= 96 ? 3 : this.view_data.assigned_to_type

      if (this.roleName == 'Vendor') {
        this.is_seen = result['data']['maintenance_request_vendor']['is_seen'] == 1 ? true:false
      }

      this.$vs.loading.close()

      //reading docs
      this.tableRead = await axios.post(`/docs/table/read/`, {
        token: this.token,
        path: `docs/maintenance-order/gallery/${viewId}`,
        document_folder_id: 20
      })

      //reading docs
      if(this.tableRead.data.uploadedD !== null) {
        for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
          var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
          var imgAsc = imgB64.toString('ascii')
          this.files.push("data:image/png;base64, " + imgAsc)
          this.fileKey.push(value.key)
        }
      }
    },
    async loadUser () {
      const result = await axios.get(`/api/user/list`, {
        headers: { 'Authorization': this.token }
      })

      this.optionUser = result['data']
      return result['data']
    },
    async loadUserPem() {
      var decoded = jwt.verify(this.token, 'secret')
      const viewId = decoded.id
      var d = await axios.get(`/user/view/${viewId}`, {
        headers: { 'Authorization': this.token }
      })
      const userD = d['data'][0]['user_role']['name']
      this.roleName = userD

      console.log('this.roleName ', this.roleName)
    },
    async acceptJob() {
      try {
        const viewId = this.$route.params.viewId
        const userAllData = JSON.parse(localStorage.userAllData)

        await axios.post(`/order/accept/${viewId}`, {
          token: this.token,
          business_name: userAllData['vendor']['business_name']
        })

        this.$vs.notify({
          color: 'success',
          title: 'Loading Page',
          text: 'Job accepted.'
        })
        this.$router.push({name:'app-order-list'})
      } catch(err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Loading Page',
          text: err
        })
      }
    },
    async rejectJob() {
      try {
        const viewId = this.$route.params.viewId
        const userAllData = JSON.parse(localStorage.userAllData)

        await axios.post(`/order/reject/${viewId}`, {
          token: this.token
        })

        this.$vs.notify({
          color: 'success',
          title: 'Loading Page',
          text: 'Job declined.'
        })
        this.$router.push({name:'app-order-list'})
      } catch(err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Loading Page',
          text: err
        })
      }
    },
    async reOpen(id) {
      this.view_data.is_submitted = 0
      this.view_data.is_assigned = 0
      this.view_data.m_request_status_id = id
      await axios.post(`/order/reopen/${this.$route.params.viewId}`, {
        token: this.token,
        data: this.view_data
      })

      this.popupActive = false
      this.loadData()
      this.$vs.notify({
        color: 'success',
        title: 'Updating Status',
        text: 'Status Changed.'
      })
    },
    async updateStatus(val) {
      this.files = []
      this.fileKey = []

      this.view_data.property_ref = localStorage.selectedParentOrgRef
      this.view_data.m_request_status_val = val
      await axios.post(`/order/update-stat/${this.$route.params.viewId}`, {
        token: this.token,
        data: this.view_data
      })

      this.popupActive = false
      this.loadData()
      this.$vs.notify({
        color: 'success',
        title: 'Updating Status',
        text: 'Status Changed.'
      })
    },
    async assignOrder() {
      this.files = []
      this.fileKey = []

      await axios.post(`/order/assign/${this.$route.params.viewId}`, {
        token: this.token,
        data: this.view_data
      })

      this.popupActive = false
      this.loadData()
      this.$vs.notify({
        color: 'success',
        title: 'Assigning work',
        text: 'Success'
      })
    },
    loadStaff () {
      var d = new Promise( async (resolve, reject)  => {
        try {
          await axios.get(`/api/staff/list`, {
              headers: {
                'Authorization': this.token,
                'property_ref': localStorage.selectedParentOrgRef
              }
            })
            .then(res => {
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            })
        } catch(err) {
          reject(err.toString('utf8'));
        }
      })

      d.then((res) => {
        console.log('res loadStaff ', res)
        this.optionStaff = res
      })
    },
    loadVendor () {
      var d = new Promise( async (resolve, reject)  => {
        try {
          await axios.get(`/api/vendor/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            })
        } catch(err) {
          reject(err.toString('utf8'));
        }
      })

      d.then((res) => {
        console.log('res loadVendor ', res)
        this.optionVendor = res
      })
    }
  },
  computed: {
    roleVal() {
      const userAllData = JSON.parse(localStorage.userAllData)

      return userAllData.user_role.val
    },
    issued_name() {
      let issued_by = null
      issued_by = this.optionUser.filter( r => r.id === parseInt(this.view_data.issued_by_id) )
      return issued_by.length === 0 ? '--' : issued_by[0]['full_name']
    },
    rfp_type_name() {
      let type_name = null
      type_name = this.optionType.filter( r => r.id === parseInt(this.view_data.rfp_type) )

      return type_name.length === 0 ? '--' : type_name[0]['name']
    },
    rfp_recipients() {
      let x = null
      let y = []

      if (JSON.parse(this.view_data.rfp_recipients) === null ) return
      this.view_data.rfp_recipients = JSON.parse(this.view_data.rfp_recipients)
      this.view_data.rfp_recipients.map((r, k) => {
        x = this.optionVendor.filter(res => res.id === r)
        y[k] = x[0]
      })

      return y
    },
    assigned_to_name() {
      let assigned = []
      if (this.view_data.assigned_to_type === 1) {
        assigned = this.optionStaff.filter(res => this.view_data.assigned_to === res.id)

        return assigned.length === 0 ? '--' : assigned[0]['full_name']
      } else {
        assigned = this.optionVendor.filter(res => this.view_data.assigned_to === res.id)

        return assigned.length === 0 ? '--' : assigned[0]['business_name']
      }
    }
  },
  async created () {
    this.$vs.loading()
    // crud
    this.showL = await mainHelper.cansee('order-list', 'list')
    this.showC = await mainHelper.cansee('order-create', 'create')
    this.showR = await mainHelper.cansee('order-read', 'read')
    this.showU = await mainHelper.cansee('order-update', 'update')
    this.showD = await mainHelper.cansee('order-delete', 'delete')

    if (!this.showR) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }

    this.accessLevel = await mainHelper.loadUserAccessLevel()
    console.log('this.accessLevel ', this.accessLevel)

    this.loadUser()
    this.loadUserPem()
    this.loadStaff()
    this.loadData()
    this.loadVendor()
  },
  mounted () {
    EventBus.$on('load-approval', () => {
      /* this.approvals = this.approvals.map(e => ({...e, status: 'Approved', completed_at: new Date()}));
      console.log('load-approval', this.approvals)
      this.$set(this.approvals, 'approvals', this.approvals.map(e => ({...e, status: 'Approved', completed_at: new Date()}))) */
      })
  },
}

</script>

<style lang="scss">

div.order-view-pop-t {
  height: 420px;
}

div.order-view-pop-f {
  height: 220px;
  width: 400px !important;
}

.vs-popup {
  width: 400px !important;
}

div.selectOption ul.vs__dropdown-menu {
  height: 150px;
}

.vel-modal[data-v-1f17a952] {
  z-index: 100000 !important;
}

#avatar-col {
  width: 10rem;
}

#page-data-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

.avatar-img {
  position: relative;
  width: 230px;
  overflow: hidden;
  padding-top: 230px;
}

.avatar-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
}

.timerDue {
  display: flex;
  justify-content: flex-end;
}

.single-counter {
  display: inline-block;
  position: relative;
  width: 50px;
  color: white;
  font-size: 10px;
  padding: 0px;
}

.single-counter .timer {
  font-size: 20px;
}

td.font-semibold {
  padding-right: 20px !important;
}

.cardGlow {
  box-shadow: 0px 4px 25px 0px rgba(var(--vs-danger),1);
  -webkit-transition: box-shadow 5s ease-out;
  -moz-transition: box-shadow 5s ease-out;
  -o-transition: box-shadow 5s ease-out;
  transition: box-shadow 5s ease-out;
}
</style>
